module.exports = __webpack_public_path__ + "ac0d6db85c53a8b6334b45d87cd4a75a.pdf";